// extracted by mini-css-extract-plugin
module.exports = {"more":"_2GIz3","moreIcon":"_2ZqjF","icon":"_17-Rt","horizontal":"_1sOGW","container":"_1N5G0"};